import { ActivitySummaryModel } from '@/models/data-lake/data-lake';
import { dataLakeAPI } from '@/providers/apis/data-lake/data-lake';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'summary-table',
})

export default class SummaryTable extends Vue {

    // ----------------------------------------------------------
    // Properties

    @Prop()
    private dateRange: any;

    private tableFields: any = [
        {
            label: 'Vendor',
            key: 'toolName',
        },
        {
            label: 'Student Name',
            key: 'studentName',
        },
        {
            label: 'Activity',
            key: 'activityName',
        },
        {
            label: 'Timespent(s)',
            key: 'timespent',
        },
    ];

    private activitiesData: any = [];

    private isStudentAccess: boolean = false;

    private currentPage: number = 1;

    private perPage: number = 10;

    private offset: number = 0;

    private isLoading: boolean = false;

    private searchTerms: string = '';

    private filterFields: any = ['studentName', 'toolName', 'activityName'];

    // -------------------------------------------------------------
    // Hooks

    private created() {
        this.isStudentAccess = !!this.$route.query.isStudentAccess;
        this.onLoadData();
    }

    // -------------------------------------------------------------
    // Actions

    private onGoBack() {
        this.$router.push(`/data-lake-report`);
    }

    private onChangePage(page: number) {
        this.currentPage = page;
        if (page * this.perPage > this.activitiesData.length) {
            this.offset = (page - 1) * this.perPage;
            this.onLoadData();
        }
    }

     // -------------------------------------------------------------
    // Methods

    private onLoadData() {
        this.isLoading = true;
        const dateRange = this.dateRange;
        const params = {
            startDate: dateRange.startDate,
            endDate: dateRange.endDate,
            offset: this.offset,
            limit: this.perPage,
            // toolname: this.activeProvider.name,
        };
        dataLakeAPI.fetchStudentsByVendor(params).then((activityData: any) => {
            this.activitiesData = this.parseActivityData(activityData);
            this.isLoading = false;
        });
    }

    private parseActivityData(activityData: ActivitySummaryModel[]) {
        const activityContent: any = [];
        activityData.forEach((tool) => {
            tool.studentList.forEach((student) => {
                student.activityList.forEach((activity) => {
                    const content = {
                        toolName: tool.toolName,
                        toolId: tool.toolId,
                        studentName: student.studentName,
                        studentId: student.studentId,
                        activityName: activity.activityName,
                        activityId: activity.activityId,
                        timespent: activity.timespent,
                    };
                    activityContent.push(content);
                });
            });
        });
        return activityContent;
    }
}
